/** Configuração pública do app (injetada no build pelo Coolify ou por .env.local no desenvolvimento). */
export const env = {
  supabaseUrl: (import.meta.env.VITE_SUPABASE_URL as string | undefined) ?? "",
  supabaseAnonKey: (import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined) ?? "",
  /** Rótulo de ambiente exibido na barra lateral (ex.: "dev", "staging"); vazio em produção. */
  /** Jitsi self-hosted da sala de vídeo (ex.: https://meet.vixio.com.br). Vazio: reuniões sem sala embutida. */
  meetUrl: (import.meta.env.VITE_MEET_URL as string | undefined) ?? "",
  /**
   * Portão de login único dos painéis de infraestrutura (worker, /gate/*). O painel troca a sessão pelo cookie do
   * portão em /portao. Também liberado na CSP (connect-src) pelo Dockerfile.
   */
  gateUrl: (import.meta.env.VITE_GATE_URL as string | undefined) || "https://gate.vixio.com.br",
  /** GlitchTip self-hosted (protocolo do Sentry), projeto do painel. Vazio: não envia erros. */
  sentryDsn: (import.meta.env.VITE_SENTRY_DSN as string | undefined) ?? "",
  envLabel: (import.meta.env.VITE_ENV_LABEL as string | undefined) ?? (import.meta.env.DEV ? "dev" : ""),
};
